<template>
  <div class="program-grup">
    <ProgramCatalogUGC
      :form="this.form"
      :categoryList="categoryList"
      :sndCategoryList="sndCategoryList"
      :formData="searchData"
      isProgram="isProgram"
      :rules="rules"
      ref="creatEditForm"
      :showMessage="false"
      @handleSubmit="handleSubmit"
      @changeSnd="changeSnd"
    ></ProgramCatalogUGC>
  </div>
</template>
<script>
import { fetchSndCategory } from '../../resource/api/index'
import { programSets, addProgramSets, editProgramSets } from '@/resource/api/program-group-management'
import ProgramCatalogUGC from '@/components/programCatalogUGC.vue'
export default {
  name: 'ProgramGroupUGC',
  components: {
    ProgramCatalogUGC
  },
  data () {
    return {
      sndObj: {},
      programSetId: '',
      isProgram: 'programs',
      categoryList: [],
      sndCategoryList: [],
      form: {
        platform: 'ugc',
        name: '',
        category: '',
        sndCategory: '',
        director: this.$store.state.router.anchorId, // 主播ID
        dsc: '',
        createBy: this.$store.state.router.createBy,
        poster: '',
        posterH: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { pattern: /^[\s\S]{1,40}$/, message: '不大于40' }
        ],
        director: [
          { required: true, message: '请输入主播ID', trigger: 'blur' }
        ],
        dsc: [
          { required: true, message: '请输入简介', trigger: 'blur' },
          { pattern: /^[\s\S]{1,80}$/, message: '不大于80个字符', trigger: 'change' }
        ],
        category: [
          { required: true, message: '请选择分类', trigger: 'change' }
        ],
        sndCategory: [
          { required: true, message: '请选择二级分类', trigger: 'change' }
        ],
        poster: [
          { required: true, message: '请上传竖海报', trigger: 'change' }
        ],
        posterH: [
          { required: true, message: '请上传横海报', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    searchData () {
      return [
        {
          prop: 'name',
          type: 'input',
          label: '标题：',
          placeholder: '请输入',
          clearable: true,
          labelWidth: '120px',
          col: [3, 3, 3]
        },
        {
          prop: 'category',
          label: '分类：',
          type: 'select',
          filterable: true,
          labelWidth: '120px',
          options: this.categoryList,
          change: this.selectChangeCategory
        },
        {
          prop: 'sndCategory',
          label: '二级分类：',
          type: 'slot',
          filterable: true,
          labelWidth: '120px'
        },
        {
          prop: 'director',
          type: 'input',
          disabled: true,
          label: '主播ID：',
          placeholder: '请输入',
          clearable: true,
          labelWidth: '120px',
          col: [3, 3, 3]
        },
        { prop: 'poster', type: 'slot', label: '竖海报：', labelWidth: '120px', className: 'poster-width' },
        { prop: 'posterH', type: 'slot', label: '横海报：', labelWidth: '120px', className: 'poster-width' },
        {
          prop: 'dsc',
          label: '内容简介：',
          labelWidth: '120px',
          type: 'slot'
        },
        {
          labelWidth: '120px',
          prop: 'submit',
          label: '',
          type: 'slot'
        }
      ]
    }
  },
  created () {
    this.pageInit()
    this.getCategoryList()
  },
  methods: {
    pageInit () {
      const routerParams = this.$route.query
      if (routerParams.programSetId) {
        this.programSetId = routerParams.programSetId
        // 获取需要编辑节目集的详情
        this.fetchProgramGroup()
      }
    },
    // 获取需要编辑节目集的详情
    fetchProgramGroup () {
      const data = {
        id: this.programSetId
      }
      programSets(data).then((res) => {
        if (res.code == 1) {
          const dataObj = res.results[0]
          this.getFormData(dataObj)
        }
      })
    },
    // 获取 FORM 表单
    getFormData (dataObj) {
      if (dataObj) {
        for (var key in dataObj) { // 数据初始化
          this.form[key] = dataObj[key]
          const value = this.form[key] == null ? '' : this.form[key]
          this.form = Object.assign({}, this.form, { key: value })
        }
        if (this.form.poster) {
          this.$nextTick(() => {
            this.$refs.creatEditForm.posterShow()
          })
        }
        if (this.form.posterH) {
          this.$nextTick(() => {
            this.$refs.creatEditForm.posterHShow()
          })
        }
        if (this.form.sndCategory) {
          this.$refs.creatEditForm.sndChoice = this.form.sndCategory.split(' ')
          this.sndCategoryList = this.sndObj[this.form.category]
        }
      }
      this.form.programSetId = this.programSetId
      this.form.platform = 'ugc'
    },
    handleSubmit () {
      if (this.programSetId) {
        if (this.form.poster.split('ugc').length == 2) {
          this.form.poster = this.form.poster.split('ugc')[1]
        }
        if (this.form.posterH.split('ugc').length == 2) {
          this.form.posterH = this.form.posterH.split('ugc')[1]
        }
        this.form.updateBy = this.$store.state.router.updateBy
        editProgramSets(this.form).then((res) => {
          if (res.code == '1') {
            this.$message({
              message: '编辑成功',
              type: 'success'
            })
            this.$router.push({
              name: 'programGroupManagement'
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
            this.pageInit()
          }
        })
      } else {
        addProgramSets(this.form).then((res) => {
          if (res.code == '1') {
            this.$message({
              message: '新增成功',
              type: 'success'
            })
            this.$router.push({
              name: 'programGroupManagement'
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
            this.pageInit()
          }
        })
      }
    },
    // 获取二级分类
    selectChangeCategory (val) {
      this.form.sndCategory = ''
      this.$refs.creatEditForm.sndChoice = []
      this.sndCategoryList = this.sndObj[val]
    },
    changeSnd () {
      let str = this.$refs.creatEditForm.sndChoice
      str = str.toString()
      str = str.replace(',', ' ')
      this.form.sndCategory = str
    },
    // 获取一级分类菜单
    // 获取分类下拉框内容
    getCategoryList: function () {
      var that = this
      that.categoryList = []
      fetchSndCategory().then((res) => {
        if (res.code == 1) {
          const data = res.result
          data.forEach(item => {
            that.categoryList.push({
              value: item.category,
              label: item.category
            })
            that.sndObj[item.category] = []
            const arr = item.sndCategory
            arr.forEach(itemIn => {
              that.sndObj[item.category].push({
                value: itemIn,
                label: itemIn
              })
            })
          })
        }
      })
    }
  }
}
</script>
<style lang="less">

</style>
